import { useCallback, useEffect, useRef, useState } from 'react';
import {
  Button,
  CustomInput,
  Modal,
  ModalBody,
  Row,
  Col,
  Form,
} from 'reactstrap';

import { Link, useHistory } from 'react-router-dom';

import logo from '@src/assets/images/logo/logo.png';
import source from '@src/assets/images/pages/create-account.svg';
import { useForm } from 'react-hook-form';
import './styles.scss';
import api from '@src/services/api';
import useJwt from '@src/auth/jwt/useJwt';
import { handleLogout } from '@store/actions/auth';
import { useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import { ContractTerms } from './ContractTerms';

interface ConfirmCancelModalProps {
  isOpen: boolean; // Define que 'isOpen' é um boolean
  onConfirm: () => void; // Função chamada ao confirmar
}

export function TermsService() {
  const [isOpenModal, setIsOpenModal] = useState(true);
  const history = useHistory();
  const [termUse, setTermUse] = useState(false);
  const [privacyPolicies, setPrivacyPolicies] = useState(false);
  const [updateFlag, setUpdateFlag] = useState(false);
  const { handleSubmit } = useForm();
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [isScrolledToEnd, setIsScrolledToEnd] = useState(false);

  const handleCancel = () => {
    setIsConfirmModalOpen(!isConfirmModalOpen); // Abre a modal de confirmação
  };

  const handleConfirmCancel = () => {
    handleClickLogout();
    // toggleConfirmModal(); // Fecha a modal de confirmação // Fecha a modal principal
  };

  const handleModalClose = () => {
    setIsOpenModal(false); // fecha a modal principal
  };

  const handleClickLogout = async () => {
    api.post('logout', null, {
      headers: {
        Authorization: `Bearer ${useJwt.getToken()}`,
      },
    });

    dispatch(handleLogout());

    queryClient.removeQueries();

    history.push('/login');
  };

  const onSubmit = useCallback(async () => {
    try {
      const data = JSON.parse(localStorage.getItem('userData') || 'null');
      const response = await api.post('accept-terms', null, {
        headers: {
          Authorization: `Bearer ${useJwt.getToken()}`,
        },
      });

      // Processar a resposta da API, se necessário
      data.ismaster_accepted_platform_terms = true;
      localStorage.setItem('userData', JSON.stringify(data));
      handleModalClose();
      setUpdateFlag((prev) => !prev);
      history.push('/dashboard/ecommerce');
      return response.data; // Retorna a resposta ou algum dado necessário
    } catch (error) {
      console.error('Erro ao aceitar os termos:', error);
      throw error;
    }
  }, []);

  const ConfirmCancelModal: React.FC<ConfirmCancelModalProps> = ({
    isOpen,
    onConfirm,
  }) => {
    // modal confirmation
    return (
      <Modal isOpen={isOpen} className="modal-dialog-centered mini-modal">
        <ModalBody className="mini-modal">
          <div className="text-center">
            <h5 className="mb-3">Tem certeza que deseja cancelar?</h5>
            <p className="text-muted">Você será deslogado do sistema.</p>
            <Row className="justify-content-center">
              <Col xs="auto">
                <Button color="primary" onClick={onConfirm}>
                  Sim
                </Button>
              </Col>
              <Col xs="auto">
                <Button color="secondary" onClick={handleCancel}>
                  Não
                </Button>
              </Col>
            </Row>
          </div>
        </ModalBody>
      </Modal>
    );
  };

  return (
    <>
      <Modal
        isOpen={isOpenModal}
        className="modal-dialog-centered modal-xl"
        modalClassName="modal-danger"
      >
        <ModalBody className="modal-body-custom">
          <div className="">
            <div className="row m-0">
              {/* Logo Section */}
              <div className="col-lg-3 d-none d-lg-flex flex-column p-0">
                <div className="d-flex justify-content-center mb-2">
                  <Link to="/" onClick={(e) => e.preventDefault()}>
                    <img src={logo} alt="Logo U2PAY" className="img-fluid" />
                  </Link>
                </div>
                <div className="w-100 d-flex justify-content-center image-container">
                  <img
                    className="img-fluid w-100"
                    src={source}
                    alt="Login Cover"
                  />
                </div>
              </div>

              {/* Main Content Section */}
              <div className="col-lg-9 col-sm-12 d-flex flex-column">
                <div className="mx-auto px-lg-3">
                  {/* Logo */}

                  {/* Terms Component */}
                  <div className="content-container d-flex flex-column mx-auto">
                    <ContractTerms
                      onScrollEnd={() => setIsScrolledToEnd(true)}
                    />
                  </div>

                  {/* Form Section */}
                  <Form onSubmit={handleSubmit(onSubmit)} className="">
                    <div className="row">
                      {/* Checkboxes */}
                      <div className="col-md-6">
                        <div className="form-check">
                          <CustomInput
                            type="checkbox"
                            label=""
                            id="termUse"
                            name="termUse"
                            onChange={() => setTermUse((s) => !s)}
                          />
                          <span className="text-primary span">
                            Termos de Uso
                          </span>
                        </div>
                        <div className="form-check">
                          <CustomInput
                            type="checkbox"
                            label=""
                            id="privacyPolicies"
                            name="privacyPolicies"
                            onChange={() => setPrivacyPolicies((s) => !s)}
                          />
                          <span className="text-primary span">
                            Políticas de Privacidade
                          </span>
                        </div>
                      </div>

                      {/* Buttons */}
                      <div className="col-md-6 d-flex pt justify-content-end justify-center">
                        <Button
                          type="button"
                          color="cancel"
                          className="me-2"
                          onClick={handleCancel}
                        >
                          Cancelar
                        </Button>
                        <Button
                          type="submit"
                          color="primary"
                          style={{
                            cursor:
                              !termUse || !privacyPolicies
                                ? 'not-allowed'
                                : 'pointer',
                          }}
                          disabled={
                            !(termUse && privacyPolicies && isScrolledToEnd)
                          }
                        >
                          Aceitar Termos
                        </Button>
                      </div>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>

      <ConfirmCancelModal // modal confirmation
        isOpen={isConfirmModalOpen}
        onConfirm={handleConfirmCancel}
      />
    </>
  );
}

export default TermsService;
